import { useTranslation } from 'react-i18next'

import { FileUpload, useImageUploadErrorToast } from '@/components/ui/file-upload'

import { getImageUrl } from '../../helpers'
import {
  AMENITY_IMAGE_ACCEPTED_TYPES,
  AMENITY_IMAGE_MAX_BYTES,
  AMENITY_IMAGE_MAX_OUTPUT_BYTES,
  AMENITY_IMAGE_OPTIMIZATION,
} from './amenity-image-upload.constants'

export interface AmenityImageUploadProps {
  image?: File | string | null
  onChange: (image: File | '') => void
  error?: string
  disabled?: boolean
}

export const AmenityImageUpload = ({
  image,
  onChange,
  error,
  disabled,
}: AmenityImageUploadProps) => {
  const { t } = useTranslation(['reservations'])
  const handleValidationError = useImageUploadErrorToast({
    acceptedTypes: AMENITY_IMAGE_ACCEPTED_TYPES,
    maxFileSize: AMENITY_IMAGE_MAX_BYTES,
    maxOutputFileSize: AMENITY_IMAGE_MAX_OUTPUT_BYTES,
  })

  const file = image instanceof File ? image : null
  const existingImageUrl = typeof image === 'string' && image ? getImageUrl(image) : undefined

  return (
    <FileUpload
      layout="maximized"
      size="large"
      previewShape="square"
      multiple={false}
      acceptedTypes={AMENITY_IMAGE_ACCEPTED_TYPES}
      maxFileSize={AMENITY_IMAGE_MAX_BYTES}
      maxOutputFileSize={AMENITY_IMAGE_MAX_OUTPUT_BYTES}
      imageOptimization={AMENITY_IMAGE_OPTIMIZATION}
      label={t('reservations:amenityForms.details.coverImage')}
      description={t('reservations:amenityForms.details.imageGuidance')}
      uploadLabel={t('reservations:amenityForms.details.uploadCoverImage')}
      files={file ? [file] : []}
      existingImageUrl={existingImageUrl}
      error={error}
      disabled={disabled}
      onChange={(files) => onChange(files[0] ?? '')}
      onValidationError={handleValidationError}
    />
  )
}
